import init from '../../../js/init';

const name = 'ourPartners';
const selector = '.our-partners';
const imagesListSelector = `${selector}__images`;
const imageSelector = `${selector}__image`;
const waveSelector = `${selector}__wave`;
const interval = 10; // in ms

init(Drupal, name, selector, root => {
  const imagesList = root.querySelector(imagesListSelector);
  const wave = root.querySelector(waveSelector);

  if (!imagesList || !wave) return;

  const handleLogos = () => {
    const margin = imagesList.style.marginLeft || '0px';
    const marginNumber = +margin.replace('px', '');
    imagesList.style.marginLeft = `${marginNumber - 1}px`;

    const firstImage = imagesList.children[0];

    if (firstImage.offsetLeft + firstImage.offsetWidth <= 0) {
      imagesList.style.marginLeft = '0px';
      imagesList.appendChild(firstImage);
    }
  };

  const handleWave = () => {
    const margin = wave.style.marginLeft || '0px';
    const marginNumber = +margin.replace('px', '');
    wave.style.marginLeft = `${marginNumber + 1}px`;

    if (wave.children[1].getBoundingClientRect().left >= window.innerWidth) {
      wave.style.marginLeft = '0px';
      wave.appendChild(wave.children[0]);
    }
  };

  setInterval(() => {
    if (imagesList.querySelector(`${imageSelector}:hover`)) return;

    handleLogos();
    handleWave();
  }, interval);
});
